import { render, staticRenderFns } from "./marketVehicle.vue?vue&type=template&id=4f585a8d&scoped=true&"
import script from "./marketVehicle.vue?vue&type=script&lang=js&"
export * from "./marketVehicle.vue?vue&type=script&lang=js&"
import style0 from "./marketVehicle.vue?vue&type=style&index=0&id=4f585a8d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f585a8d",
  null
  
)

export default component.exports